import type {
  Interaction,
  FeedbackInteraction,
  PraiseInteraction,
  DebriefInteraction,
  AllReasonOption,
} from '@momentum/types';
import type { EmployeeMap } from '../types/interaction-table.types';

export const getParticipantNames = (
  interaction: Interaction,
  currentEmployeeId: string,
  employeeMap: EmployeeMap,
  unknownLabel: string
): string[] => {
  if (interaction.type === 'debrief') {
    const debrief = interaction as DebriefInteraction;
    return [
      debrief.creatorId,
      ...debrief.coreParticipants,
      ...(debrief.otherParticipants || []),
    ]
      .filter((id) => id !== currentEmployeeId)
      .map((id) => employeeMap.get(id)?.name || unknownLabel);
  } else {
    const praiseOrFeedback = interaction as
      | PraiseInteraction
      | FeedbackInteraction;
    const receiverId = praiseOrFeedback.receiverId;
    if (receiverId === currentEmployeeId) {
      return [employeeMap.get(interaction.creatorId)?.name || unknownLabel];
    }
    return [employeeMap.get(receiverId)?.name || unknownLabel];
  }
};

export const getReasonSelection = (
  interaction: Interaction
): AllReasonOption | null => {
  if (interaction.type === 'debrief') {
    return null;
  }
  const praiseOrFeedback = interaction as
    | PraiseInteraction
    | FeedbackInteraction;
  return (
    (praiseOrFeedback.formData?.[
      'reason-selection'
    ]?.[0] as AllReasonOption | null) ?? null
  );
};
